import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {PaymentScheduleSearchResult} from "../types/PaymentScheduleSearchResult";
import {PaymentScheduleSearchParams} from "../types/PaymentScheduleSearchParams";

export const useGetPaymentSchedule = (params: PaymentScheduleSearchParams) => {
	const { data, refetch, isRefetching } = useQuery({
		queryKey: [params],
		enabled: false,
		queryFn: async () => await apiClient.get('payment-schedule/list', {
			params: params
		}) as PaymentScheduleSearchResult
	});

	return {
		data,
		isRefetching,
		refetch
	};
};
